import axios from 'axios';
import store from '../store';

import consulta from './consulta';
import consultaColetiva from './consultaColetiva';
import conviteUsuario from './conviteUsuario';
import convitePaciente from './convitePaciente';
import exame from './exame';
import gestacao from './gestacao';
import grupo from './grupo';
import grupoExame from './grupoExame';
import historico from './historico';
import internacao from './internacao';
import informacaoParto from './informacaoParto';
import medicaoGlicemia from './medicaoGlicemia';
import medicaoPressaoArterial from './medicaoPressaoArterial';
import paciente from './paciente';
import planoDeSaude from './planoDeSaude';
import resultadoDeExame from './resultadoDeExame';
import textoEditavel from './textoEditavel';
import tokenSenha from './tokenSenha';
import ultrassom from './ultrassom';
import usuario from './usuario';
import vacina from './vacina';
import vacinacao from './vacinacao';
import notaProntuario from './notaProntuario';

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL || 'http://localhost:3000/';
// Auth header após refresh
axios.defaults.headers.common.Authorization = `Bearer ${store.getters.token}`;

export default {
  consulta,
  consultaColetiva,
  conviteUsuario,
  convitePaciente,
  exame,
  gestacao,
  grupo,
  grupoExame,
  historico,
  internacao,
  informacaoParto,
  medicaoGlicemia,
  medicaoPressaoArterial,
  paciente,
  planoDeSaude,
  resultadoDeExame,
  textoEditavel,
  tokenSenha,
  ultrassom,
  usuario,
  vacina,
  vacinacao,
  notaProntuario,
};
